import PropTypes from 'prop-types'
import { InputTextArea } from '../../../common/html/input/InputTextArea'
import classes from './index.module.scss'

export const InputForm = ({
  value,
  title,
  containerStyle,
  isShowLabel,
  onChange,
  isValid,
  textInvalid,
  readOnly,
  defaultValue,
  wrapClassName,
}) => {
  return (
    <div className={[classes.inputForm, wrapClassName].join(' ')}>
      <InputTextArea
        isShowLabel={isShowLabel}
        placeHolder={title}
        rows={1}
        containerStyle={{ ...containerStyle }}
        onChange={onChange}
        isValid={isValid}
        textInvalid={textInvalid}
        readOnly={readOnly}
        defaultValue={defaultValue}
        value={value}
        style={{ color: readOnly ? '#9C9C9C' : '#3A414B', resize: 'none' }}
      />
    </div>
  )
}

InputForm.defaultProps = {
  placeHolder: PropTypes.string,
  isShowLabel: PropTypes.bool,
  containerStyle: PropTypes.object,
  wrapClassName: PropTypes.string,
}

InputForm.defaultProps = {
  placeHolder: '',
  isShowLabel: true,
  containerStyle: {},
  wrapClassName: '',
}
